<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="networkElementList"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("system.label.NetworkSystem") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push('/createSystem').catch(() => {})"
                  size="small"
                  >{{ $t("system.label.CreateNetworkSystem") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("system.label.SystemCode") }}</vs-th>
              <vs-th>{{ $t("system.label.SystemName") }}</vs-th>
              <vs-th>{{ $t("system.label.Status") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("system.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="networkElementList"
                v-for="(networkElementList, index) in data"
              >
                <vs-td :data="networkElementList.systemcode">{{
                  networkElementList.systemcode
                }}</vs-td>
                <vs-td :data="networkElementList.systemname">{{
                  networkElementList.systemname
                }}</vs-td>
                <vs-td :data="networkElementList.status">{{
                  networkElementList.status
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('system.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editCreatesystem(networkElementList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('system.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      class="icon_row"
                      @click.stop="
                        deletePopup = true;
                        delId = networkElementList.id;
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <delete-popup
        :deletePopup="deletePopup"
        :title="$t('setup.label.NetworkSystem')"
        @deletePressed="deleteCurrencyData(delId)"
        @cancelPressed="deletePopup = false"
      >
      </delete-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      deleteProvisioningPopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapGetters({
      networkElementList: "provisioningConfig/getnetworkSystemList",
    }),
  },
  methods: {
    async getSystemData() {
      this.loading = true;
      try {
        await this.$store.dispatch("provisioningConfig/setnetworkelementData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteCurrencyData(id) {
      try {
        this.deletePopup = false;
        await this.$store.dispatch(
          "provisioningConfig/setDeletenetworkElement",
          id
        );
        await this.getSystemData();
        this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
      } catch (error) {
        this.$toasted.error("Something Went Wrong", {
          duration: 2000,
        });
      }
    },

    editCreatesystem(id) {
      this.$router.push(`/editCreateSystem/${id}`);
    },
  },
  mounted() {
    this.getSystemData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
</style>
